class NewsLetterPopup extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'luxury:newsletter-popup';
    this.closeStorageKey = 'luxury:newsletter-popup-closed-at';
    this.popup = this;

    this.classes = {
      bodyClass: 'modal-open',
      activeClass: 'active',
      closingClass: 'closing',
    };

    // Popup shows after 2 seconds
    this.popupDelay = 2 * 1000;

    // Hide popup for 10 minutes after closing
    this.closeDelay = 10 * 60 * 1000; // 10 minutes in milliseconds

    // If there is a form message, only open if recently closed timer is not active
    if (this.querySelector('.form-message') && !this.wasRecentlyClosed()) {
      this.open();
    }

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    // Only show popup if:
    // 1. user has not already signed up
    // 2. user has not closed it in the last 10 minutes
    if (!this.getCookie(this.cookieName) && !this.wasRecentlyClosed()) {
      this.init();
    }
  }

  init() {
    if (!this.popup) {
      return;
    }

    setTimeout(() => {
      if (!this.getCookie(this.cookieName) && !this.wasRecentlyClosed()) {
        this.open();
      }
    }, this.popupDelay);
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.popup.classList.contains(this.classes.activeClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    document.body.classList.remove(this.classes.bodyClass);

    if (
      this.dataset.newsletterpopup == 'true' &&
      !this.getCookie(this.cookieName) &&
      !this.wasRecentlyClosed()
    ) {
      document.body.classList.add(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);
    }
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      document.body.classList.remove(this.classes.bodyClass);
    }, 500);

    // Save close time in localStorage
    localStorage.setItem(this.closeStorageKey, Date.now().toString());
  }

  wasRecentlyClosed() {
    const closedAt = localStorage.getItem(this.closeStorageKey);

    if (!closedAt) {
      return false;
    }

    const now = Date.now();
    const diff = now - parseInt(closedAt, 10);

    if (diff < this.closeDelay) {
      return true;
    }

    // Remove expired timestamp
    localStorage.removeItem(this.closeStorageKey);
    return false;
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0; path=/`;
  }
}

customElements.define('newsletter-popup', NewsLetterPopup);